module.exports = {"530428001":"红河街道","530428002":"澧江街道","530428003":"甘庄街道","530428101":"曼来镇","530428102":"因远镇","530428201":"龙潭乡","530428202":"羊街乡","530428203":"那诺乡","530428204":"洼垤乡","530428205":"咪哩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530428.json
// module id = 2707
// module chunks = 0